import metaLogoUrl from 'assets/images/MetaLine.svg';
import linkedinLogoUrl from 'assets/images/linkedIn.svg';
import metaSquareLogoUrl from 'assets/images/MetaSquare.svg';
import linkedinSquareLogoUrl from 'assets/images/linkedInNew.svg';
import talentUrl from 'assets/images/doodles/add-talent.svg';
import whatsappLogoUrl from 'assets/images/whatsApp.svg';
import whatsappSquareLogoUrl from 'assets/images/WhatsappSquare.svg';
import leadManualSquareUrl from 'assets/images/leadManualSquare.svg';
import smsLogoUrl from 'assets/images/SmsSquare.svg';
import smsLogoSquareUrl from 'assets/images/SmsSquare.svg';
import emailLogoUrl from 'assets/images/EmailSquare.svg';
import emailLogoSquareUrl from 'assets/images/EmailSquare.svg';
import websiteWidgetLogoUrl from 'assets/images/WebsiteWidgetSquare.svg';
import websiteWidgetLogoSquareUrl from 'assets/images/WebsiteWidgetSquare.svg';
import atsLogoUrl from 'assets/images/AtsSquare.svg';
import atsLogoSquareUrl from 'assets/images/AtsSquare.svg';
import webChatLogoUrl from 'assets/images/WebChatSquare.svg';
import webChatLogoSquareUrl from 'assets/images/WebChatSquare.svg';
import segmentLogoUrl from 'assets/images/SegmentSquare.svg';
import segmentLogoSquareUrl from 'assets/images/SegmentSquare.svg';

export enum TalentSource {
    Meta = 'meta',
    Linkedin = 'linkedin',
    Whatsapp = 'whatsapp',
    Manual = 'manual',
    Sms = 'sms',
    Email = 'email',
    WebsiteWidget = 'website_widget',
    Ats = 'ats',
    WebChat = 'web_chat',
    Segment = 'segment',
}

export const getTalentSourceDisplayName = (talentSource: TalentSource): string => {
    switch (talentSource) {
        case TalentSource.Meta:
            return 'Meta';
        case TalentSource.Linkedin:
            return 'LinkedIn';
        case TalentSource.Whatsapp:
            return 'WhatsApp';
        case TalentSource.Manual:
            return 'Manual';
        case TalentSource.Sms:
            return 'SMS';
        case TalentSource.Email:
            return 'Email';
        case TalentSource.WebsiteWidget:
            return 'Website Widget';
        case TalentSource.Ats:
            return 'ATS';
        case TalentSource.WebChat:
            return 'Web chat';
        case TalentSource.Segment:
            return 'Segment';
    }
};

export const getTalentSourceImageUrl = (talentSource: TalentSource): string => {
    switch (talentSource) {
        case TalentSource.Meta:
            return metaLogoUrl;
        case TalentSource.Linkedin:
            return linkedinLogoUrl;
        case TalentSource.Whatsapp:
            return whatsappLogoUrl;
        case TalentSource.Manual:
            return talentUrl;
        case TalentSource.Sms:
            return smsLogoUrl;
        case TalentSource.Email:
            return emailLogoUrl;
        case TalentSource.WebsiteWidget:
            return websiteWidgetLogoUrl;
        case TalentSource.Ats:
            return atsLogoUrl;
        case TalentSource.WebChat:
            return webChatLogoUrl;
        case TalentSource.Segment:
            return segmentLogoUrl;
    }
};

export const getTalentSourceSquareImageUrl = (talentSource: TalentSource): string => {
    switch (talentSource) {
        case TalentSource.Meta:
            return metaSquareLogoUrl;
        case TalentSource.Linkedin:
            return linkedinSquareLogoUrl;
        case TalentSource.Whatsapp:
            return whatsappSquareLogoUrl;
        case TalentSource.Manual:
            return leadManualSquareUrl;
        case TalentSource.Sms:
            return smsLogoSquareUrl;
        case TalentSource.Email:
            return emailLogoSquareUrl;
        case TalentSource.WebsiteWidget:
            return websiteWidgetLogoSquareUrl;
        case TalentSource.Ats:
            return atsLogoSquareUrl;
        case TalentSource.WebChat:
            return webChatLogoSquareUrl;
        case TalentSource.Segment:
            return segmentLogoSquareUrl;
    }
};
